import { render, staticRenderFns } from "./products-list.vue?vue&type=template&id=4b8c6310&scoped=true"
import script from "./products-list.vue?vue&type=script&lang=js"
export * from "./products-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8c6310",
  null
  
)

export default component.exports